import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #898b8e;

  img {
    width: 120px;
    height: 120px;
    align-self: center;
  }

  h3 {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    text-align: center;
    width: 308px;
    margin-top: 20px;
  }

  div {
    margin-top: 24px;

    p {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      margin-top: 8px;
      margin-bottom: 36px;
    }

    ul {
      list-style-type: none;

      li {
        text-align: center;
        color: #898b8e;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }
    }
  }

  .info {
    margin-top: 32px;
    font-size: 16px;
    font-weight: 400;
  }
`;
